import styled from "styled-components";

import { mixins } from "@similarweb/styles";

export const StyledFilterLabelText = styled.span`
    ${mixins.truncateText()};
    min-width: 0;
`;

export const StyledFilterOverflowCount = styled.span`
    flex-shrink: 0;
    white-space: nowrap;
`;
